import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import {
	Backdrop,
	Box,
	Card,
	CardMedia,
	CardActionArea,
	CircularProgress,
	DialogContent,
	Dialog,
	DialogTitle,
	Fab,
	Grid,
	Paper,
	Typography,
} from "@mui/material";

import { makeStyles } from "@mui/styles";
import KIcon from "../Icons/KIcon";

import palette from "../../theme/palette";

const useStyles = makeStyles((theme) => ({
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: "#fff",
	},
	root: {
		display: "flex",
		alignItems: "center",
	},
	wrapper: {
		margin: theme.spacing(1),
		position: "relative",
	},

	fabProgress: {
		color: palette.primary.main,
		position: "absolute",
		top: -6,
		left: -6,
		zIndex: 1,
	},
}));
function Item(props) {
	const classes = useStyles();
	return (
		<Card className={classes.root}>
			<CardActionArea>
				<CardMedia className={classes.media} image={props.item.img} title="**" />
			</CardActionArea>
		</Card>
	);
}
export default function UserDashboard() {
	const classes = useStyles();
	const [loading, setLoading] = useState(true);
	const [state, setState] = useState({ open: false });

	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/dashboard/", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						console.log(res);
						//setValues(res.payload);
						if (!res.session) {
							window.location.href = "/login";
						}
						if (res.r !== null) {
							window.location.href = res.r;
						}
						if (res.r === null) {
							setLoading(false);
							setState({ ...state, open: true, pld: res.pld });
						}
						break;
					case "err":
						break;
					default:
						break;
				}
			});
		return () => { };
	}, []);

	const handleButtonClick = () => {
		if (!loading) {
			setSuccess(false);
			setLoading(true);
		}
	};
	if (state.pld) console.log(state.pld.c);
	return (
		<div>
			<div className={classes.root}>
				<Backdrop open={loading} className={classes.backdrop}>
					<div className={classes.wrapper}>
						<Fab
							aria-label="wait bk"

							onClick={handleButtonClick}
						>
							<KIcon height={40} width={40} />
						</Fab>
						{<CircularProgress size={68} className={classes.fabProgress} />}
					</div>
				</Backdrop>
			</div>
			<div>
				<Dialog aria-labelledby="add-user-dialog" open={state.open} maxWidth="md" fullWidth={false}>
					<DialogContent dividers style="background-color: rgba(244, 246, 248, 0.81)">
						<Grid container spacing={2}>
							<Grid item xs={4}>
								<img width="180" height="300" src="/images/bbot.png" />
							</Grid>
							<Grid item xs={8}>
								<Grid container spacing={2}>
									{state && state.pld && state.pld.c && state.pld.c.indexOf("AM") >= 0 && (
										<Grid item xs={state.pld && state.pld.c ? 12 / state.pld.c.length : 4}>
											<a href="/dashboarda">
												<Paper style="padding: 10px;">
													<Typography variant="h5" style="margin-bottom: 10px;">
														Espace ambassadeur
													</Typography>
												</Paper>
											</a>
										</Grid>
									)}
									{state && state.pld && state.pld.c && state.pld.c.indexOf("VN") >= 0 && (
										<Grid item xs={state.pld && state.pld.c ? 12 / state.pld.c.length : 4}>
											<a href="/dashboardv">
												<Paper style="padding: 10px;">
													<Typography variant="h5" style="margin-bottom: 10px;">
														Espace vendeur
													</Typography>
												</Paper>
											</a>
										</Grid>
									)}
									{state && state.pld && state.pld.c && state.pld.c.indexOf("PR") >= 0 && (
										<Grid item xs={state.pld && state.pld.c ? 12 / state.pld.c.length : 4}>
											<a href="/dashboardp">
												<Paper style="padding: 10px;">
													<Typography variant="h5" style="margin-bottom: 10px;">
														Espace prospect
													</Typography>
												</Paper>
											</a>
										</Grid>
									)}
								</Grid>
								<Typography variant="h5" style="margin-bottom: 10px; margin-top: 10px;">
									A quel dossier souhaitez-vous accéder ?
								</Typography>
								<Paper style="padding: 10px;">
									<Grid container spacing={2}>
										{state &&
											state.pld &&
											state.pld.d &&
											state.pld.d.map((d) => {
												return (
													<Grid xs={12} item>
														<Paper
															onClick={() => {
																window.location.href = "/";
															}}
															style="padding: 10px;"
														>
															<Box
																display="flex"
																flexDirection="row"
																alignItems="center"
																justifyContent="space-between"
															>
																<Box>
																	<Typography variant="body1" gutterBottom>
																		{d.n}
																	</Typography>
																</Box>
																<Box>
																	<Typography variant="body1" gutterBottom>
																		{d.role}
																	</Typography>
																</Box>
															</Box>
														</Paper>
													</Grid>
												);
											})}
									</Grid>
								</Paper>
							</Grid>
						</Grid>
					</DialogContent>
				</Dialog>
			</div>
		</div>
	);
}
